import { render, staticRenderFns } from "./GameShowPanel.vue?vue&type=template&id=796f37bc&scoped=true"
import script from "./GameShowPanel.vue?vue&type=script&lang=js"
export * from "./GameShowPanel.vue?vue&type=script&lang=js"
import style0 from "./GameShowPanel.vue?vue&type=style&index=0&id=796f37bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "796f37bc",
  null
  
)

export default component.exports